export default __webpack_public_path__ + "static/media/chevron.5c3eedc2.svg";